import PropTypes from 'prop-types';

import {
  imagePropTypes,
  itinerarySideBarPropTypes,
  linkPropTypes,
  progressBarStepPropTypes,
  selectedOptionsPropTypes,
} from '../../../propTypes';
import {
  leadBookerPropTypes,
  partyMemberPropTypes,
  roomsPropTypes,
} from '../BookingFieldset/PropTypes';
import {
  currencyDepositAndTotalPricePropTypes,
  currencyDepositAndTotalPricePropTypesArrayPropTypes,
} from '../../../util/currency';

export const labelsPropTypes = PropTypes.shape({
  addressFieldsetTitle: PropTypes.string,
  atolProtectedText: PropTypes.string,
  chestSizeGuideLink: linkPropTypes,
  chestSizePlaceholderOptionText: PropTypes.string,
  failedToRetrieveCheckoutProcessSettingsMessage: PropTypes.string,
  findAddressButtonText: PropTypes.string,
  insuranceFieldsetTitle: PropTypes.string,
  insuranceNotRequiredOptionText: PropTypes.string,
  insuranceRequiredOptionText: PropTypes.string,
  invalidPaymentOptionMessage: PropTypes.string,
  invalidTourIdMessage: PropTypes.string,
  isBookerAMemberLabelText: PropTypes.string,
  leadPartyMemberFieldsetTitle: PropTypes.string,
  linkedBookingHeadingText: PropTypes.string,
  linkedBookingLabelText: PropTypes.string,
  linkedBookingNameLabelText: PropTypes.string,
  linkedBookingNamePlaceholderText: PropTypes.string,
  linkedBookingReferenceLabelText: PropTypes.string,
  linkedBookingReferencePlaceholderText: PropTypes.string,
  partyMemberFieldsetSubHeaderText: PropTypes.string,
  partyMemberFieldsetTitle: PropTypes.string,
  placeholderTexts: PropTypes.object,
  preferredCardImage: imagePropTypes,
  roomAllocationFieldsetTitle: PropTypes.string,
  sessionInvalidTourIdMessage: PropTypes.string,
  submitButtonText: PropTypes.string,
  titleOptions: PropTypes.arrayOf(PropTypes.string),
  validationReviewFields: PropTypes.string,
  validationDateOfBirthFormat: PropTypes.string,
  validationLeadMinimumAge: PropTypes.string,
  validationDateOfBirthInvalid: PropTypes.string,
  validationMissingRoomAllocations: PropTypes.string,
});

export const passengerDetailsLoadPropTypes = PropTypes.shape({
  chestSizeOptions: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
    })
  ),
  dialCodes: PropTypes.arrayOf(PropTypes.string),
  errorCode: PropTypes.number,
  errorMessage: PropTypes.string,
  excludeDialCodes: PropTypes.bool,
  insuranceText: PropTypes.string,
  isBookerAMember: PropTypes.bool,
  itinerarySideBar: itinerarySideBarPropTypes,
  leadBooker: leadBookerPropTypes,
  linkedBookingName: PropTypes.string,
  linkedBookingReference: PropTypes.string,
  partyMembers: PropTypes.arrayOf(partyMemberPropTypes),
  pricePerCurrency: currencyDepositAndTotalPricePropTypesArrayPropTypes,
  progressBarSteps: PropTypes.arrayOf(progressBarStepPropTypes),
  rooms: PropTypes.arrayOf(roomsPropTypes),
  selectedOptions: selectedOptionsPropTypes,
  tourDescription: PropTypes.string,
  tourFromDate: PropTypes.string,
  tourName: PropTypes.string,
  tournamentName: PropTypes.string,
  tourToDate: PropTypes.string,
});
